import { render, staticRenderFns } from "./mc-app-debug.vue?vue&type=template&id=0a086f4a"
import script from "./mc-app-debug.vue?vue&type=script&lang=js"
export * from "./mc-app-debug.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports